/* ==========================================================================
   ILAVIYA — product page behaviour
   Gallery, zoom, variant resolution, quantity, sticky add-to-cart, delivery.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-ilr-product]');
  if (!root) return;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var toast = function (m) { if (window.ILAVIYA) window.ILAVIYA.toast(m); };

  var money = function (cents) {
    // Mirrors the shop's format closely enough for live variant updates.
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '₹' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  /* ---- Gallery ----------------------------------------------------------- */
  var track = $('[data-ilr-gallery-track]', root);
  var slides = $$('[data-ilr-slide]', root);
  var thumbs = $$('[data-ilr-thumb]', root);
  var dots = $$('[data-ilr-dot]', root);
  var current = 0;
  var isMobile = function () { return window.innerWidth <= 749; };

  function updateActiveUI(idx) {
    current = idx;
    slides.forEach(function (s, n) { s.classList.toggle('is-active', n === current); });
    thumbs.forEach(function (t, n) { 
      var isActive = (n === current);
      t.setAttribute('aria-current', String(isActive)); 
      if (isActive && t.parentElement.style.display !== 'none') {
         if (t.scrollIntoViewIfNeeded) t.scrollIntoViewIfNeeded();
         else t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    });
    dots.forEach(function (d, n) {
      d.classList.toggle('is-active', n === current);
    });
    // pause any video that scrolled out of view
    $$('video', root).forEach(function (v, n) { if (n !== current && !v.paused) v.pause(); });
  }

  function show(i) {
    if (!slides.length) return;
    var targetIdx = (i + slides.length) % slides.length;
    var target = slides[targetIdx];
    if (target && target.style.display === 'none') {
      var vis = slides.filter(function(s) { return s.style.display !== 'none'; });
      if (vis.length) targetIdx = slides.indexOf(vis[0]);
    }

    updateActiveUI(targetIdx);

    if (track && isMobile()) {
      var targetSlide = slides[targetIdx];
      if (targetSlide) {
        track.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
      }
    }
  }

  function showNext(dir) {
    var vis = slides.filter(function(s) { return s.style.display !== 'none'; });
    if (!vis.length) return;
    var idx = vis.indexOf(slides[current]);
    if (idx === -1) idx = 0;
    var nIdx = (idx + dir + vis.length) % vis.length;
    show(slides.indexOf(vis[nIdx]));
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-ilr-thumb'), 10)); });
  });
  dots.forEach(function (d) {
    d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-ilr-dot'), 10)); });
  });
  var prev = $('[data-ilr-gal-prev]', root);
  var next = $('[data-ilr-gal-next]', root);
  if (prev) prev.addEventListener('click', function () { showNext(-1); });
  if (next) next.addEventListener('click', function () { showNext(1); });

  // Native scroll tracking on mobile track so dots update in real-time while swiping
  if (track) {
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (!isMobile()) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var w = track.clientWidth;
        if (!w) return;
        var scrollLeft = track.scrollLeft;
        var idx = Math.round(scrollLeft / w);
        var vis = slides.filter(function(s) { return s.style.display !== 'none'; });
        if (vis[idx]) {
          var realIndex = slides.indexOf(vis[idx]);
          if (realIndex !== -1 && realIndex !== current) {
            updateActiveUI(realIndex);
          }
        }
      }, 30);
    }, { passive: true });
  }

  // Keyboard arrows when the gallery has focus
  var stage = $('.ilr-gal__stage', root);
  if (stage) {
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') showNext(-1);
      if (e.key === 'ArrowRight') showNext(1);
    });
  }

  /* ---- Zoom: track cursor as transform origin ---------------------------- */
  $$('[data-ilr-zoom]', root).forEach(function (z) {
    z.addEventListener('mousemove', function (e) {
      var r = z.getBoundingClientRect();
      z.style.setProperty('--ox', ((e.clientX - r.left) / r.width) * 100 + '%');
      z.style.setProperty('--oy', ((e.clientY - r.top) / r.height) * 100 + '%');
    });
  });

  /* ---- Variants ---------------------------------------------------------- */
  var variants = [];
  try {
    var raw = $('[data-ilr-variants]');
    if (raw) variants = JSON.parse(raw.textContent);
  } catch (e) { variants = []; }

  var idInput = $('[data-ilr-variant-id]', root);
  var priceWrap = $('[data-ilr-price]', root);
  var atc = $('[data-ilr-atc]', root);
  var satcPrice = $('[data-ilr-satc-price]', root);
  var skuEl = $('[data-ilr-sku]', root);

  function selectedOptions() {
    var opts = [];
    $$('[data-ilr-opt-input]:checked', root).forEach(function (i) {
      opts[parseInt(i.getAttribute('data-option-position'), 10)] = i.value;
    });
    return opts;
  }

  function findVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] !== undefined && v.options[j] !== opts[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  // Grey out option values that cannot combine with the current selection
  function refreshAvailability() {
    var opts = selectedOptions();
    $$('[data-ilr-opt-input]', root).forEach(function (input) {
      var pos = parseInt(input.getAttribute('data-option-position'), 10);
      var probe = opts.slice();
      probe[pos] = input.value;
      var found = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < probe.length; j++) {
          if (probe[j] !== undefined && v.options[j] !== probe[j]) { ok = false; break; }
        }
        if (ok) { found = v; break; }
      }
      input.disabled = !found || !found.available;
    });
  }

  function updateVariant() {
    var v = findVariant(selectedOptions());

    // Native Shopify Variant Media Filtering
    if (v) {
      var selectedMediaId = v.featured_media ? v.featured_media.id : null;
      var allVariantMediaIds = [];
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].featured_media) {
          allVariantMediaIds.push(variants[i].featured_media.id);
        }
      }

      var els = $$('[data-media-id]', root);
      els.forEach(function (el) {
        var mid = parseInt(el.getAttribute('data-media-id'), 10);
        if (mid === selectedMediaId || allVariantMediaIds.indexOf(mid) === -1) {
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });
      
      if (selectedMediaId) {
        for (var j = 0; j < slides.length; j++) {
          var slideMid = parseInt(slides[j].getAttribute('data-media-id'), 10);
          if (slideMid === selectedMediaId) {
            show(j);
            break;
          }
        }
      } else if (slides[current] && slides[current].style.display === 'none') {
        for (var k = 0; k < slides.length; k++) {
          if (slides[k].style.display !== 'none') {
            show(k);
            break;
          }
        }
      }
    }

    // reflect the chosen value next to each option name
    $$('[data-option-position]', root).forEach(function (input) {
      var pos = input.getAttribute('data-option-position');
      var checked = $('[data-option-position="' + pos + '"]:checked', root);
      var label = $('[data-ilr-opt-value="' + pos + '"]', root);
      if (label) {
        if (checked) {
          label.textContent = checked.value;
        } else if (input.getAttribute('data-is-size') === 'true') {
          label.textContent = 'Select Size';
        }
      }
    });

    refreshAvailability();

    if (!v) {
      if (atc) {
        atc.disabled = true;
        var s = atc.querySelector('span');
        if (s) s.textContent = 'Unavailable';
      }
      return;
    }

    if (idInput) idInput.value = v.id;
    if (skuEl) skuEl.textContent = v.sku || '';

    if (priceWrap) {
      var html = '<span class="ilr-price">' + money(v.price) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
        html += '<s class="ilr-price ilr-price--was">' + money(v.compare_at_price) + '</s>';
        html += '<span class="ilr-price ilr-price--off">(' + pct + '% OFF)</span>';
      }
      priceWrap.innerHTML = html;
    }
    if (satcPrice) satcPrice.textContent = money(v.price);

    var isSizeChosen = isSizeSelected();
    if (atc) {
      atc.disabled = false;
      var span = atc.querySelector('span');
      if (span) {
        if (!isSizeChosen && $('[data-is-size="true"]', root)) {
          span.textContent = 'ADD TO BAG';
        } else {
          span.textContent = v.available ? 'ADD TO BAG' : 'SOLD OUT';
          if (!v.available) atc.disabled = true;
        }
      }
    }

    // keep the URL shareable
    if (history.replaceState && isSizeChosen) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    }

    // jump the gallery to this variant's image
    if (v.featured_media && v.featured_media.position) show(v.featured_media.position - 1);
  }

  /* ---- Size Selection Handling ------------------------------------------ */
  var pendingAction = null;
  var selectedSheetVal = null;
  var selectedSheetPos = null;
  var sizeSheet = $('#ilr-size-sheet');
  var sizeDoneBtn = $('[data-ilr-size-done]', sizeSheet);

  function isSizeSelected() {
    var sizeInputs = $$('[data-is-size="true"]', root);
    if (!sizeInputs.length) return true;
    return sizeInputs.some(function (i) { return i.checked; });
  }

  function highlightOnPageSize() {
    var opt = $('[data-option-is-size="true"]', root) || $('.ilr-opt', root);
    if (opt) {
      opt.classList.remove('has-error');
      void opt.offsetWidth;
      opt.classList.add('has-error');
      opt.scrollIntoView({ behavior: 'smooth', block: 'center' });
      toast('Please select a size');
    }
  }

  function openSizeSheet(action) {
    pendingAction = action || 'atc';
    if (sizeSheet) {
      var checkedSize = $('[data-is-size="true"]:checked', root);
      selectedSheetVal = checkedSize ? checkedSize.value : null;
      selectedSheetPos = checkedSize ? checkedSize.getAttribute('data-option-position') : null;

      $$('.ilr-size-sheet__pill', sizeSheet).forEach(function (pill) {
        var isAct = checkedSize && pill.getAttribute('data-size-value') === checkedSize.value;
        pill.classList.toggle('is-active', !!isAct);
      });

      if (sizeDoneBtn) {
        sizeDoneBtn.disabled = !checkedSize;
      }
      sizeSheet.removeAttribute('hidden');
    } else {
      highlightOnPageSize();
    }
  }

  // Handle Size Sheet Pill click (select pill, enable DONE button)
  if (sizeSheet) {
    $$('.ilr-size-sheet__pill', sizeSheet).forEach(function (pill) {
      pill.addEventListener('click', function () {
        $$('.ilr-size-sheet__pill', sizeSheet).forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        selectedSheetVal = pill.getAttribute('data-size-value');
        selectedSheetPos = pill.getAttribute('data-option-position');
        if (sizeDoneBtn) sizeDoneBtn.disabled = false;
      });
    });

    // Handle DONE Button click
    if (sizeDoneBtn) {
      sizeDoneBtn.addEventListener('click', function () {
        if (!selectedSheetVal || selectedSheetPos === null) return;
        var targetInput = $('[data-option-position="' + selectedSheetPos + '"][value="' + CSS.escape(selectedSheetVal) + '"]', root);
        if (targetInput) {
          targetInput.checked = true;
          targetInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        sizeSheet.setAttribute('hidden', '');

        setTimeout(function () {
          if (pendingAction === 'checkout') {
            var buyNowBtn = $('.ilr-btn--buy-now', root);
            if (buyNowBtn) buyNowBtn.click();
            else if (form) form.submit();
          } else {
            if (form) {
              if (typeof form.requestSubmit === 'function') form.requestSubmit(atc);
              else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
            }
          }
          pendingAction = null;
        }, 100);
      });
    }
  }

  // Remove error class on size change
  $$('[data-is-size="true"]', root).forEach(function (input) {
    input.addEventListener('change', function () {
      var opt = $('[data-option-is-size="true"]', root);
      if (opt) opt.classList.remove('has-error');
    });
  });

  $$('[data-ilr-opt-input]', root).forEach(function (i) {
    i.addEventListener('change', updateVariant);
  });
  if (variants.length) refreshAvailability();

  /* ---- Quantity ---------------------------------------------------------- */
  var qtyInput = $('[data-ilr-qty-input]', root);
  $$('[data-ilr-qty]', root).forEach(function (b) {
    b.addEventListener('click', function () {
      if (!qtyInput) return;
      var step = parseInt(b.getAttribute('data-ilr-qty'), 10);
      var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
      qtyInput.value = next;
    });
  });

  /* ---- Add to cart (AJAX) ------------------------------------------------ */
  var form = $('#ilr-product-form', root);
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!isSizeSelected()) {
        e.preventDefault();
        highlightOnPageSize();
        return;
      }
      // let "Buy It Now" post normally through to checkout
      if (e.submitter && e.submitter.name === 'checkout') return;
      e.preventDefault();

      var btn = atc;
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = '<span>Adding…</span>'; }

      var formData = new FormData(form);
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not add to bag');
          toast('Added to bag');
          
          if (res.d.sections) {
            var drawer = document.querySelector('cart-drawer');
            if (drawer) drawer.renderContents(res.d);
          }
          if (window.ILAVIYA) window.ILAVIYA.refreshCart();
        })
        .catch(function (err) { toast(err.message); })
        .then(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
        });
    });
  }

  /* ---- Sticky add to cart / Buy Now (Floating & Docking) ----------------- */
  var satc = $('[data-ilr-satc]');
  var buySection = $('.ilr-buy', root) || atc;
  if (satc && buySection && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('ilr-has-satc');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var shouldFloat = !en.isIntersecting;
        satc.classList.toggle('is-in', shouldFloat);
        if (buySection) {
          buySection.classList.toggle('is-docked', en.isIntersecting);
        }
      });
    }, { threshold: [0, 0.15] });
    io.observe(buySection);
  }

  var satcAdd = $('[data-ilr-satc-add]');
  if (satcAdd && form) {
    satcAdd.addEventListener('click', function () {
      if (!isSizeSelected()) {
        openSizeSheet('atc');
        return;
      }
      if (typeof form.requestSubmit === 'function') form.requestSubmit(atc);
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  /* ---- Delivery estimate ------------------------------------------------- */
  $$('[data-ilr-delivery]', root).forEach(function (wrap) {
    var input = $('input', wrap);
    var btn = $('button', wrap);
    var out = $('.ilr-delivery__out', wrap);
    if (!input || !btn || !out) return;
    btn.addEventListener('click', function () {
      var pin = (input.value || '').replace(/\D/g, '');
      if (pin.length !== 6) {
        out.style.color = 'var(--ilr-sale)';
        out.textContent = 'Please enter a valid 6-digit pincode.';
        return;
      }
      var days = 2 + (parseInt(pin.charAt(5), 10) % 5);
      var d = new Date();
      d.setDate(d.getDate() + days);
      out.style.color = 'var(--ilr-success)';
      out.textContent =
        'Delivery by ' +
        d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' }) +
        ' · Free shipping · COD available';
    });
  });
})();
